<template>
    <Head title="Brands" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        Brands
                    </h2>
                </div>
            </div>
        </template>
        <BreadCrumbs :items="breadCrumbs"></BreadCrumbs>
        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <form ref="searchForm" @submit.prevent="form.get('brands')">
                <admin-search-form :term="form.search" v-model="form.search"></admin-search-form>
            </form>
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="min-w-full leading-normal">
                            <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                                <tr class="hidden md:table-row">
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">ID</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">Name</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">
                                        <select v-model="filter" @change="filterFeatured" class="text-sm lg:text-base">
                                            <option v-for="option in options" v-bind:value="option.value">{{ option.text }}</option>
                                        </select>
                                    </th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody class="my-3 flex-1 md:flex-none">
                                <tr v-if="brands.data.length" v-for="brand of brands.data" class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 md:border-t md:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 md:table-row flex-col w-full flex-wrap">
                                    <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block md:hidden">ID</label>
                                        {{ brand.id }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block md:hidden">Name</label>
                                        {{ brand.name }}
                                    </td>
                                    <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                        <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block md:hidden">Featured</label>
                                        {{ brand.featured ? 'Yes' : 'No'}}
                                    </td>
                                    <td class="px-5 py-5 lg:border-r lg:border-b border-grey-200 bg-white text-center lg:text-left text-sm md:text-base">
                                        <admin-link target="_blank"
                                                    class="bg-grey-100 text-dark"
                                                    :href="'/brands/' + brand.slug">View
                                        </admin-link>
                                        <admin-link :href="route('admin.brands.edit', brand)">Edit</admin-link>
                                        <admin-link type="button" class="bg-red" @click="showDeleteModal(brand.id)">
                                            Delete
                                        </admin-link>
                                        <admin-delete-modal v-if="deleteModalIdToShow === brand.id"
                                                            :msg="modalMessage"
                                                            :type="modalType"
                                                            @toggle-delete-modal="hideDeleteModal()"
                                                            @delete-item="deleteItem(brand.id)"></admin-delete-modal>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td class="py-6 bg-red" colspan="4" align="center">
                                        <p class="text-white font-bold">No brands found</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <admin-pagination class="mt-6" :links="brands.links"></admin-pagination>
                    </div>
                </div>
            </div>
        </div>
        <ToTopLink>To Top</ToTopLink>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue';
import {Head, useForm} from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3';
import AdminLink from "@/Components/Admin/AdminLink";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";
import AdminPagination from "@/Components/Admin/AdminPagination";
import {Inertia} from "@inertiajs/inertia";
import ToTopLink from "@/Components/Admin/ToTopLink";
export default {
    name: "Index",
    components:
    {
        ToTopLink,
        AdminPagination,
        AdminDeleteModal,
        AdminSearchForm,
        BreadCrumbs,
        AdminLink,
        Head,
        BreezeAuthenticatedLayout,
        Link
    },
    props : {
        featured: String,
        brands: Object,
        term: String
    },
    data()
    {
        return {
            filter: this.featured,
            breadCrumbs: [
                { title : 'Brands', path: '/admin/brands'}
            ],
            options: [
                { value: "", text: 'Featured' },
                { value: '1', text: 'Yes' },
                { value: '0', text:  'No' }
            ],
            deleteModalIdToShow: false,
            modalMessage: 'Are you sure you want to delete this brand?',
            modalType: 'Brand',
            form: useForm({
                search: this.term
            })
        }
    },
    methods: {
        filterFeatured(event)
        {
            var selected = event.target.value;
            var search_term = this.term;

            if(this.term === null)
            {
                search_term = "";
            }

            if(selected === "")
            {
                Inertia.visit("/admin/brands?search="+search_term);
            }
            else
            {
                Inertia.visit("/admin/brands?search="+search_term+"&featured="+selected);
            }
        },
        showDeleteModal(id) {
            this.deleteModalIdToShow = id;
        },
        hideDeleteModal() {
            this.deleteModalIdToShow = false;
        },
        deleteItem(brand) {
            this.$inertia.delete(route("admin.brands.destroy", brand));
        }
    }
}
</script>

<style>

</style>
